<template>
  <div>
    <van-skeleton title  :row="0" :loading="loading">
    <div class="vehicle-list" v-if="cheguaList.length>0">
      <div v-for="item in cheguaList" :key="item.id">
        <div class="vehicle-item" >
          <div class="vehicle-item-content">

            <div class="bpm-status" v-if="item.bpmStatus == 1">
              <van-tag type="danger">未提交</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.bpmStatus == 2">
              <van-tag type="warning">待审核</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.bpmStatus == 3">
              <van-tag type="primary">审核成功</van-tag>
            </div>

            <div class="info-title">车挂号：{{item.cheguahao}}</div>
            <div class="info-info-title-2" v-if="item.sscd">所属车队：{{item.sscd}}</div>

            <div class="info-info-title-2" v-if="item.guanticaizhi">罐体材质：{{item.guanticaizhi}}</div>
            <div class="info-info-title-2">荷载：{{item.xingshizhenghdzzl?item.xingshizhenghdzzl:0}}KG</div>
            <div class="info-info-title-2">整备质量：{{item.zhengbeizhiliang?item.zhengbeizhiliang:0}}KG</div>
            <div class="info-info-title-2">行驶证有效期：{{item.xingshizhengyxq}}</div>
            <div class="info-info-title-2">罐检有效期：{{item.guanjianyxq}}</div>
          </div>

        </div>
      </div>
    </div>
    <div v-else>
      <van-empty description="您尚未绑定车辆，请先搜索车辆">
        <div class="btns-box">
          <div class="search-btn-box">
            <van-button round type="danger" block class="bottom-button" @click="steamSearchCheguaVehicle">搜  索  车  辆</van-button>
          </div>
          <div class="padding-box"></div>
          <div class="add-btn-box">
            <van-button round type="default" block class="bottom-button" @click="addCheguaVehicle">未找到，新增车辆</van-button>
          </div>
        </div>
      </van-empty>
    </div>
    </van-skeleton>
  </div>
</template>
<script>
import api from '@/fetch/api';
import {  Toast } from 'vant';

export default {
  data(){
    return {
      cheguaList:[],
      loading:true
    };
  },
  methods:{
    getCheguaList(openid) {
      var that = this;
      api.getCheguaList(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.cheguaList = resData.data;
          that.loading = false;
          if(that.cheguaList.length>0 && that.cheguaList[0].bpmStatus == "3")
          {
            switch (that.cheguaList[0].cangshi) {
                case "01":
                  that.cheguaList[0].cangshiTitle = "单舱";
                  break;
                case "02":
                  that.cheguaList[0].cangshiTitle = "双舱";
                  break;
                case "03":
                  that.cheguaList[0].cangshiTitle = "三舱";
                  break;
                  default:
                  that.cheguaList[0].cangshiTitle = "";
              }

              that.$emit("update-props",true);
              that.$emit("update-info",'cheguahao',that.cheguaList[0]);
          }
          else{
            that.$emit("update-props",false);
          }

        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
    //搜索车辆
    steamSearchCheguaVehicle()
    {
      this.$router.push({
        name: 'addAllCar'
      })
    },
    addCheguaVehicle()
    {
      this.$router.push({
        name: 'addchegua'
      })
    },
  },
  created(){
    var openid = this.$store.state.wx_info.openid;
    this.getCheguaList(openid);
    this.$emit("update-props",false);
  },
}
</script>
<style lang="scss">
.vehicle-list {
    margin-bottom: 4.75rem;
    .vehicle-item {
        margin: 1rem 1rem 0;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .vehicle-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .info-title {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1;
            }
            .info-info-title-2 {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }
        }
        .vehicle-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }

    }
}
.bpm-status {
    float: right;
}

.padding-box{
  height: 1rem;
}
</style>
